export default "__VITE_ASSET__rTYYibVL__"